import React from "react";
import { Badge, Box, Button, ButtonGroup, Flex, Text } from "@chakra-ui/react";
import { ClientProfileType } from "../types";

type ClientProfileTypeSelectorProps = {
  value: ClientProfileType;
  onChange: (value: ClientProfileType) => void;
};

export const ClientProfileTypeSelector = ({
  value,
  onChange,
}: ClientProfileTypeSelectorProps) => (
  <Box bg="white" borderWidth="1px" borderColor="gray.200" rounded="md" p={4}>
    <Flex justify="space-between" align="center" mb={3} gap={3}>
      <Text fontWeight="semibold" color="gray.700">
        Client profile type
      </Text>
      <Badge colorScheme="teal">Client profiles</Badge>
    </Flex>
    <ButtonGroup isAttached w="full">
      <Button
        flex={1}
        colorScheme="teal"
        variant={value === "HOMEOWNER" ? "solid" : "outline"}
        onClick={() => onChange("HOMEOWNER")}
      >
        Homeowner
      </Button>
      <Button
        flex={1}
        colorScheme="teal"
        variant={value === "ORGANIZATION" ? "solid" : "outline"}
        onClick={() => onChange("ORGANIZATION")}
      >
        Organization
      </Button>
    </ButtonGroup>
  </Box>
);
